// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import axios from 'axios';
import App from './App';
import router from './router';
import KeyMap from './lib/KeyMap';
import util from './lib/util';
import './style/_all.scss';

Vue.config.productionTip = false;
Vue.prototype.KeyMap = KeyMap;
Vue.prototype.$http = axios;

Vue.filter('formatTime', date => util.formatTime(date));

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js